import { render, staticRenderFns } from "./CourseTocIntroEntry.vue?vue&type=template&id=5ec0fe8c&scoped=true&"
import script from "./CourseTocIntroEntry.vue?vue&type=script&lang=js&"
export * from "./CourseTocIntroEntry.vue?vue&type=script&lang=js&"
import style0 from "./CourseTocIntroEntry.vue?vue&type=style&index=0&id=5ec0fe8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec0fe8c",
  null
  
)

/* custom blocks */
import block0 from "./CourseTocIntroEntry.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports